// Compteurs Instagram / TikTok : de 0 à la valeur quand la section entre à l'écran (une fois), format de la
// langue du site (37 300) ou court (37,3 k). Valeur finale directe si prefers-reduced-motion.
// Vidéos des vignettes : lecture muette automatique tant qu'elles sont à l'écran, pause dès qu'elles en sortent,
// jamais de son, rien si prefers-reduced-motion (même logique que assets/snk-ugc-videos.js).
if (!customElements.get('snk-social')) {
  customElements.define(
    'snk-social',
    class SnkSocial extends HTMLElement {
      connectedCallback() {
        this.autoplayVideos();
        this.counters = [...this.querySelectorAll('[data-snk-count]')];
        const lang = document.documentElement.lang || 'fr';
        this.format = new Intl.NumberFormat(lang, this.dataset.short === 'true' ? { notation: 'compact', maximumFractionDigits: 1 } : {});
        this.counters.forEach((el) => (el.textContent = this.format.format(Number(el.dataset.snkCount))));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.counters.forEach((el) => (el.textContent = this.format.format(0)));
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.animate();
        }, { threshold: 0.4 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.videoObserver?.disconnect();
      }

      autoplayVideos() {
        const videos = this.querySelectorAll('video[data-snk-autoplay]');
        if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) {
              target.muted = true;
              target.play().catch(() => {});
            } else {
              target.pause();
            }
          });
        }, { threshold: 0.5 });
        videos.forEach((video) => this.videoObserver.observe(video));
      }

      animate() {
        const start = performance.now();
        const duration = 1400;
        const step = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          this.counters.forEach((el) => (el.textContent = this.format.format(Math.round(Number(el.dataset.snkCount) * eased))));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }
  );
}
